import React, { FC } from 'react'
import { makeStyles, Typography } from 'transfix-ui/core'
import MissingInfo from './MissingInfo'

interface ITrailerNumberProps {
  trailerNumber: string
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    height: '100%',
    gap: 3,
  },
})

const TrailerNumber: FC<ITrailerNumberProps> = ({ trailerNumber }) => {
  const styles = useStyles()

  if (trailerNumber) {
    return (
      <Typography variant='body1' className={styles.root}>
        {trailerNumber}
      </Typography>
    )
  }
  return <MissingInfo />
}

export default TrailerNumber
